namespace Cfnc {
    "use strict";

    interface ITopNav {
        log: (msg, data?, showToast?) => void;
        activate: () => void;
    }

    class TopNav implements ITopNav {
        static controllerId: string = "topnav";
        cfncUrl: string;
        javaUrl: string;
        umbracoUrl: string;
        transitionsUrl: string;
        residencyUrl: string;
        currentTab: string;
        helpLink: string;
        isLoggedIn: boolean;
        user: any;
        searchText: string;
        ncAssistUrl: string;
        static $inject: Array<string> = ["$rootScope", "$window", "common", "config", "$route", "$timeout"];

        log: (msg, data?, showToast?) => void;

        constructor(private $rootScope: ng.IRootScopeService, private $window: ng.IWindowService, private common: ICommonFactory, private config: IConfig, private $route: ng.route.IRouteService, private $timeout: ng.ITimeoutService) {
            this.log = common.logger.getLogFn(TopNav.controllerId);
            this.common.authentication.isLoggedIn().then((loggedIn) => {
                if (loggedIn) {
                    this.isLoggedIn = true;
                } else {
                    this.isLoggedIn = false;
                }

                if (this.isLoggedIn) {
                    this.user = this.common.authentication.user;
                }
                $rootScope.$applyAsync();
            });

            $rootScope.$on(config.events.login, (event, user: any) => {
                this.isLoggedIn = true;
                this.user = user;
                $rootScope.$applyAsync();
            });

            $rootScope.$on(config.events.logout, (event) => {
                this.isLoggedIn = false;
                this.user = null;
                $rootScope.$applyAsync();
            });
            this.activate();
        }

        activate(): void {
            this.cfncUrl = this.config.cfncUrl;
            this.javaUrl = this.config.javaUrl;
            this.umbracoUrl = this.config.umbracoUrl;
            this.transitionsUrl = this.config.transitionsUrl;
            this.residencyUrl = this.config.residencyUrl;
            this.currentTab = "";
            this.ncAssistUrl = this.config.ncassistUrl;
            this.checkRouteSettings();

            this.$rootScope.$on("$routeChangeSuccess",
                () => {
                    this.$timeout(() => {
                        this.checkRouteSettings();
                    });
                });

            this.common.activateController([], TopNav.controllerId);
        }

        login = () => {
            this.common.authentication.login();
        };

        register = () => {
            this.common.authentication.register();
        };

        logout = () => {
            this.common.authentication.logout();
        };

        search = () => {
            this.$window.location.href = `${this.umbracoUrl}/search?q=${encodeURI(this.searchText)}`;
        };

        checkRouteSettings = () => {
            var route: any = this.$route.current;
            if (route.settings) {
                switch (route.settings.parent) {
                    case "MyCfnc":
                        this.helpLink = "/help/helpmycfnc.jsp";
                        break;
                    case "Plan":
                        this.helpLink = "/help/helpplan.jsp";
                        break;
                    case "Apply":
                        this.helpLink = "/help/helpapply.jsp";
                        break;
                    default:
                        this.helpLink = "#";
                        break;
                }
            } else {
                this.helpLink = "#";
            }
        }

    }

    angular.module("app").controller(TopNav.controllerId, TopNav);
}